import {
  GetAllEnrollmentsInDto,
  GetAllEnrollmentsOutDto,
} from "../../../types/enrollment.dto";

export const GET_ALL_ENROLLMENTS = "GET_ALL_ENROLLMENTS";
export const GET_ALL_ENROLLMENTS_SUCCESS = "GET_ALL_ENROLLMENTS_SUCCESS";
export const GET_ALL_ENROLLMENTS_ERROR = "GET_ALL_ENROLLMENTS_ERROR";
export const RESET_GET_ALL_ENROLLMENTS = "RESET_GET_ALL_ENROLLMENTS";

export interface GetAllEnrollments {
  type: typeof GET_ALL_ENROLLMENTS;
  payload: GetAllEnrollmentsOutDto;
}

export interface GetAllEnrollmentsSuccess {
  type: typeof GET_ALL_ENROLLMENTS_SUCCESS;
  payload: GetAllEnrollmentsInDto;
}

export interface GetAllEnrollmentsError {
  type: typeof GET_ALL_ENROLLMENTS_ERROR;
  payload: string | boolean;
}

export interface ResetGetAllEnrollments {
  type: typeof RESET_GET_ALL_ENROLLMENTS;
  payload: null;
}

export interface State {
  data: GetAllEnrollmentsInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetAllEnrollments
  | GetAllEnrollmentsSuccess
  | GetAllEnrollmentsError
  | ResetGetAllEnrollments;
